import { FormAdapterBase } from '../form-adapter-base';
import { FormGroup, Validators } from '@angular/forms';
import { CustomerFormGroup } from '../../interfaces/customer';
import { phoneNumberValidator } from '../../validators/phone-number-validator';

export class CustomerValidatorAdapter<T extends FormGroup> extends FormAdapterBase<T, CustomerFormGroup> {

    private applied = false;

    public apply(): void {
        this.addValidators();
    }

    private addValidators(): void {
        // We only want to apply this once
        if (this.applied) {
            return;
        }

        const customerForm = this.getTargetForm();

        customerForm.get('firstName')!.setValidators([Validators.required]);
        customerForm.get('lastName')!.setValidators([Validators.required]);

        customerForm.get('email')!.setValidators([Validators.required, Validators.email]);
        customerForm.get('phone')!.setValidators([Validators.required, phoneNumberValidator()]);
        customerForm.get('dateOfBirth')!.setValidators([Validators.required]);

        // required by default unless specifically set as false
        if (this.extraConfig['requireDateOfBirth'] === false) {
            customerForm.get('dateOfBirth')?.removeValidators([Validators.required]);
        }

        customerForm.updateValueAndValidity();
        this.applied = true;
    }
}
